import { render } from "./CalendarHeader.vue?vue&type=template&id=10d1cfb2"
import script from "./CalendarHeader.vue?vue&type=script&lang=js"
export * from "./CalendarHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/los4/mnt/OutHouse/los/Documents/htdocs/LosPrograms/Life/regLosers/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__